import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button, Checkbox, Toggle } from 'components/FormComponents';

export const CustomFieldInclusion = ({ structure, disabled = false, onChange }) => {
  const { t } = useTranslation();
  const customFields = structure?.custom_fields || [];
  if (customFields.length === 0) return null;

  const included = !!structure.include_custom_fields;
  const includedCount = customFields.filter(field => field.include_in_billing).length;
  const allIncluded = includedCount === customFields.length;

  const toggleField = (fieldId, checked) => {
    if (disabled) return;
    onChange(
      true,
      customFields.map(field =>
        field.id === fieldId ? { ...field, include_in_billing: checked } : field,
      ),
    );
  };

  const setAll = checked =>
    onChange(
      true,
      customFields.map(field => ({ ...field, include_in_billing: checked })),
    );

  return (
    <section className="mt-14">
      <div className="flex w-full items-center justify-between gap-6">
        <div>
          <h3 className="m-0 mb-1 text-3xl font-semibold text-text-primary">
            {t('company.tabs.billing.customFields.title')}
          </h3>
          <p className="m-0 text-xl text-text-secondary">
            {t('company.tabs.billing.customFields.description')}
          </p>
        </div>
        <Toggle
          name="include_custom_fields"
          disabled={disabled}
          inputProps={{
            checked: included,
            onChange: event => onChange(event.target.checked, customFields),
          }}
        />
      </div>
      {included && (
        <div
          className={cn('mt-6 overflow-hidden rounded-xl border border-border-primary bg-white', {
            'opacity-60': disabled,
          })}
          aria-busy={disabled}>
          <div className="flex items-center justify-between gap-4 bg-white px-5 py-2">
            <span className="text-lg text-text-secondary">
              {t('company.tabs.billing.customFields.included', {
                included: includedCount,
                total: customFields.length,
              })}
            </span>
            <Button type="link" small disabled={disabled} onClick={() => setAll(!allIncluded)}>
              {allIncluded
                ? t('company.tabs.billing.customFields.clearAll')
                : t('company.tabs.billing.customFields.selectAll')}
            </Button>
          </div>
          {customFields.map(field => (
            <label
              key={field.id}
              className={cn(
                'm-0 flex items-center border-t border-border-primary px-5 py-1 font-normal transition-colors',
                disabled ? 'cursor-default' : 'cursor-pointer hover:bg-surface-secondary',
              )}>
              <Checkbox
                name={`custom_field_${field.id}`}
                checked={!!field.include_in_billing}
                disabled={disabled}
                label={<span className="text-xl text-text-primary">{field.text}</span>}
                onChange={checked => toggleField(field.id, checked)}
              />
            </label>
          ))}
        </div>
      )}
    </section>
  );
};
